import React, {useEffect, useState, Fragment, useRef} from 'react';
import {connect} from "react-redux";
//import GLBViewer from "./GLBViewer";
import LightIntensitySlider from "./workspaceComponents/LightIntensitySlider";
import LightingSwitch from "./workspaceComponents/LightingSwitch";
import SqftStore from "../../canvas/store/sqftStore";
import SeparateModelGLBViewer from "./glbViewer/SeparateModelGLBViewer";
import ExportButton from "./workspaceComponents/ExportButton";
import config from "../../canvas/store/sqftConfig";
import sqftConfig from "../../canvas/store/sqftConfig";
import {SQFT_AR3D_GLB_VIEWER} from "../../../constants";
import SingleModelGLBViewer from "./glbViewer/SingleModelGLBViewer";
import ScreenshotButton from "./workspaceComponents/ScreenshotButton";
import store from "../../../../../store";
import {setMultiLoader} from "../../../../../actions/actionFunctions";
import {loadScriptPromise} from "../../../../../misc/loadScript";
import {ASYNC_SCRIPTS} from "../../../../../loadingLogic";
import useDebugOverlay from "./useDebugOverlay";
import BackgroundColorPicker from "./workspaceComponents/BackgroundColorPicker";
import {isProd} from "../../../../../misc/fabricatorHardcode";
//import SeparateModelGLBViewerV2 from "./glbViewer/SeparateModelGLBViewerV2";
//import GLBViewerModels from "./GLBViewerModels";

const ShapesThreeJsViewer = (props) => {
  const {cabinetsGlb, isMobile} = props;
  const {SQFTViewMode} = props;
  const canvasRef = useRef(null); // Changed to useRef for consistency
  const viewGLRef = useRef(null); // Use a ref to persist the GLBViewer instance
  const lightIntensity = 20;
  const minLightningValue = 0;
  const maxLightningValue = 140;
  useDebugOverlay(false);
  const [bgColor, setBgColor] = useState("#cccccc");

  // Handler for background color change
  const handleBackgroundColorChange = (color) => {
    // color.hex contains the new hex color
    setBgColor(color.hex);
    // If viewer is instantiated and has the method, call it to update background
    if (viewGLRef.current && typeof viewGLRef.current.setBackgroundColor === "function") {
      viewGLRef.current.setBackgroundColor(color.hex);
    }
  };

  useEffect(() => {
    // ******************* EVENT LISTENERS ******************* //
    // const onMouseMove = (event) => {
    //   viewGL.onMouseMove(event);
    // }
    // const onMouseDown = (event) => {
    //   viewGL.onMouseDown(event);
    // }
    // const onMouseUp = (event) => {
    //   viewGL.onMouseUp(event);
    // }
    // const onWheel = (event) => {
    //   viewGL.onWheel(event);
    // }
    const handleResize = () => {
      if (canvasRef.current && viewGLRef.current) {
        viewGLRef.current.onWindowResize(window.innerWidth, window.innerHeight);
      }
    };

    const cleanup = () => {
      if (viewGLRef.current) {
        viewGLRef.current.stopAnimation();
        viewGLRef.current.dispose();
        if (viewGLRef.current.renderer) {
          this.renderer.forceContextLoss();
          this.renderer.dispose();
        }
        viewGLRef.current = null;
        SqftStore.viewGL = null;
      }
      if (window.gc) {
        window.gc();
      }
      window.removeEventListener('resize', handleResize);
    };

    const initializeViewer = async () => {
      await loadScriptPromise(ASYNC_SCRIPTS.three, "three");

      if (!canvasRef.current) return;
      store.dispatch(setMultiLoader({ activeStep: 0, visible: true, finished: false }));

      cleanup();

      let viewGL;
      switch (sqftConfig.threeD.glbViewer) {
        case SQFT_AR3D_GLB_VIEWER.singleModel:
          //this viewer will load models using Vlad's api:
          viewGL = new SingleModelGLBViewer(canvasRef.current, cabinetsGlb, lightIntensity, isMobile);
          break;
        case SQFT_AR3D_GLB_VIEWER.separateModels:
        default:
          //this viewer will load models separately (see also setCabinetGLBFromCabinetsSet):
          viewGL = new SeparateModelGLBViewer(canvasRef.current, cabinetsGlb, lightIntensity, isMobile);
          viewGL.setBackgroundColor(bgColor);
          viewGL.startAnimation();
          await viewGL.modelsLoader.loadAllModels();
          viewGL.closeMultiLoader();
      }

      viewGLRef.current = viewGL;
      SqftStore.viewGL = viewGL;

      // ******************* INIT LISTENERS *******************
      // canvas.addEventListener('mousemove', onMouseMove);
      // canvas.addEventListener('mousedown', onMouseDown);
      // canvas.addEventListener('mouseup', onMouseUp);
      // canvas.addEventListener('wheel', onWheel);
      window.addEventListener('resize', handleResize);
      handleResize();
    };

    initializeViewer();

    return cleanup;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasRef, cabinetsGlb, SQFTViewMode]);

  return (
    <Fragment>
      <div className={"threeDWorkspace-tools"}>
        { config.isDevMode() ? <LightIntensitySlider
            intensityValue={lightIntensity}
            minValue={minLightningValue}
            maxValue={maxLightningValue} />
          : "" }
        { config.isDevMode() ? <ExportButton/> : "" }
        { config.isDevMode() ? <LightingSwitch viewGLRef={viewGLRef} /> : "" }
        <ScreenshotButton />
        { !isProd()
          ? <BackgroundColorPicker color={bgColor}
                                   onChange={handleBackgroundColorChange} /> : "" }
      </div>
      <canvas className="threeDWorkspace-canvas" ref={canvasRef} />
    </Fragment>
  );
}

const mapStateToProps = (store) => ({
  cabinetsGlb: store.sqftState.cabinetsGlb,
  isMobile: store.serverState.isMobile,
  SQFTViewMode: store.sqftState.SQFTViewMode,
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(ShapesThreeJsViewer);
